export default "__VITE_ASSET__CHPiD_YJ__"